import ActionWrapper from "modules/MemberList/ActionWrapper";
import TableWrapper, {
  TableWrapperProps,
} from "modules/MemberList/TableWrapper";

import { FieldActionIcon, FieldText } from "components/Table/Field";
import Filter from "./Filter";

import { useTranslationContext } from "context/TranslationContext";

import { TFinalSort, TTableRecord } from "components/Table/types";
import { TGetCorpGlobalFilter } from "pages/Search/Corporation/Model/types";

interface CorporationGlobalSearchMemberListProps extends TableWrapperProps {
  sort?: Record<string, TFinalSort>;
  filter?: Partial<TGetCorpGlobalFilter>;
  onClickAction?: (record: TTableRecord, actionType: string) => void;
  onFilter?: (filter: Partial<TGetCorpGlobalFilter>) => void;
  onSearch?: (keyword: string) => void;
}

const CorporationGlobalSearchMemberList = ({
  sort,
  filter,
  onFilter,
  onSearch,
  ...rest
}: CorporationGlobalSearchMemberListProps) => {
  const { t } = useTranslationContext();

  return (
    <TableWrapper
      {...rest}
      action={
        <ActionWrapper keyword={filter?.keyword} onSearch={onSearch}>
          <Filter filter={filter} onFilter={onFilter} />
        </ActionWrapper>
      }
      fields={[
        {
          title: t("corporation_name"),
          key: "name",
          width: "16%",
          imageKey: "profilePicture",
          imageLabelKey: "name",
          sort: sort?.["name"],
          withImage: true,
          component: FieldText,
        },
        {
          title: t("no_of_members"),
          key: "numOfMember",
          width: "15%",
          sort: sort?.["numOfMember"],
          component: FieldText,
        },
        {
          title: t("businesses"),
          key: "numOfBusinessEstablishment",
          width: "15%",
          sort: sort?.["numOfBusinessEstablishment"],
          component: FieldText,
        },
        {
          title: t("organizations"),
          key: "numOfOrganization",
          width: "15%",
          sort: sort?.["numOfOrganization"],
          component: FieldText,
        },
        {
          title: t("job_titles"),
          key: "numOfJob",
          width: "15%",
          sort: sort?.["numOfJob"],
          component: FieldText,
        },
        {
          title: t("description"),
          key: "description",
          width: "20%",
          sort: sort?.["description"],
          component: FieldText,
        },
        {
          key: "action",
          width: "5%",
          component: FieldActionIcon,
        },
      ]}
    />
  );
};

export default CorporationGlobalSearchMemberList;
